import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Select2Data } from 'ng-select2-component';
import { LocalCampaignMediaStatisticsFilters, RenaultLocalCampaignOrderListDTO, RenaultLocalCampaignOrderListFilterDTO } from '../models/renault-local-campaign-order-dto';
import { LocalCampaignTelemarketingOrderDataStatisticsModel, LocalCampaignTelemarketingStatisticsModel, LocalCampaignTelemarketingStatisticsTable } from '../models/renault-local-campaign-telemarketing-order-dto';

@Injectable({
  providedIn: 'root'
})

export class LocalCampaignTelemarketingOrderService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultLocalCampaignTelemarketingOrder/";

  constructor(private http: HttpClient) { }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public getCampaignOrderListCampaign(idCampaignMedia: number, idBrand: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignOrderListCampaign/' + idCampaignMedia + '/' + idBrand);
  }

  public getCampaignOrderList(data: RenaultLocalCampaignOrderListFilterDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "GetCampaignOrderList", data);
  }

  public getLocalCampaignTelemarketingOrderStatistics(idOrders: number[]): Observable<LocalCampaignTelemarketingOrderDataStatisticsModel> {
    return this.http.post<LocalCampaignTelemarketingOrderDataStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingOrderStatistics/', idOrders);
  }

  getLocalCampaignTelemarketingLoadCallExcel(idOrder: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingLoadCallExcel/' + idOrder;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  public get(id: string): Observable<RenaultLocalCampaignOrderListDTO> {
    return this.http.get<RenaultLocalCampaignOrderListDTO>(this.pathAPI + this.controller + 'GetOrder/' + id);
  }


  public GetLocalCampaignTelemarketingStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignTelemarketingStatisticsModel> {
    return this.http.post<LocalCampaignTelemarketingStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingStatistics/', filters);
  }

  public GetLocalCampaignTelemarketingStatisticsTable(filters: LocalCampaignMediaStatisticsFilters): Observable<LocalCampaignTelemarketingStatisticsTable[]> {
    return this.http.post<LocalCampaignTelemarketingStatisticsTable[]>(this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingStatisticsTable/', filters);
  }

  downloadExcelLocalCampaignTelemarketingStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  public loadLocalCampaignTelemarketingCallsExcel(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "LoadLocalCampaignTelemarketingCallsExcel", data);
  }

  downloadExcelLocalCampaignTelemarketingOrderStatistics(filters: RenaultLocalCampaignOrderListFilterDTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingOrderStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  downloadExcelLocalCampaignTelemarketingOrderCallComment(idOrder: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignTelemarketingOrderCallComment/' + idOrder;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }
}
